import { render, staticRenderFns } from "./RestructuringInterestForm.vue?vue&type=template&id=d60267a4&scoped=true&"
import script from "./RestructuringInterestForm.vue?vue&type=script&lang=js&"
export * from "./RestructuringInterestForm.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "d60267a4",
  null
  
)

export default component.exports